export default "__VITE_ASSET__hiFxKRma__"